import { Validators } from "@angular/forms";
import { FormType, Properties, OutlineProperties } from "../properties.model";
import { EffectsType } from "../ui-effects.model";

export const outlineForm: Properties = {
  propertyType: EffectsType.Outline,
  label: 'Outline',
  forms: [
    {
      id: OutlineProperties.OutlineInnerOuter,
      label: 'Inner Outline',
      type: FormType.Checkbox,
      defaultValue: true
    },
    {
      id: OutlineProperties.OutlineColor,
      label: 'Color',
      type: FormType.Color,
      placeholder: "#Hex Color",
      defaultValue: '#FFFFFF'
    },
    {
      id: OutlineProperties.OutlineWidth,
      label: 'Width',
      type: FormType.SliderNumber,
      defaultValue: .5,
      validators: [Validators.required],
      sliderOptions: {
        min: .01,
        max: 1,
        step: 0.01
      },
    },
    {
      id: OutlineProperties.OutlineOpacity,
      label: 'Opacity',
      type: FormType.SliderNumber,
      defaultValue: 1,
      sliderOptions: {
        min: 0,
        max: 1,
        step: 0.01
      }
    },
  ],
  changeHandler: () => {}
}
